import { useEffect, useState } from "react";

export default function BadgesGrid({ badges: provided }) {
  const [badges, setBadges] = useState(provided || null);

  useEffect(() => {
    if (provided) return;
    import("@/lib/api").then(({ default: api }) => {
      api.get("/engagement/badges").then((r) => setBadges(r.data)).catch(() => setBadges([]));
    });
  }, [provided]);

  if (!badges) return <p className="text-sm text-stone-500">Loading…</p>;
  const earned = badges.filter((b) => b.earned);
  const locked = badges.filter((b) => !b.earned);

  return (
    <div className="space-y-4" data-testid="badges-grid">
      <div className="text-xs uppercase tracking-[0.15em] text-stone-500 font-semibold">
        Earned · {earned.length} / {badges.length}
      </div>
      <ul className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3">
        {earned.map((b) => <Badge key={b.key} b={b} earned />)}
        {locked.map((b) => <Badge key={b.key} b={b} earned={false} />)}
      </ul>
    </div>
  );
}

function Badge({ b, earned }) {
  return (
    <li
      className={`rounded-2xl border p-3 text-center transition-all ${
        earned
          ? "border-amber-200 bg-gradient-to-br from-amber-50 to-yellow-50 shadow-sm"
          : "border-stone-200 bg-stone-50 opacity-60"
      }`}
      data-testid={`badge-${b.key}${earned ? "-earned" : "-locked"}`}
    >
      <div className={`text-3xl mb-1 ${earned ? "" : "grayscale"}`}>{b.icon}</div>
      <div className={`text-xs font-medium ${earned ? "text-amber-900" : "text-stone-600"}`}>{b.name}</div>
      <div className="text-[10px] text-stone-500 mt-1 leading-tight">{b.description}</div>
    </li>
  );
}
